import { Types } from './types'

const initialState = {
    // dataCategory: [],
    dataImage:{
        paging :{},
        rows : [],
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        // case Types.SAVE_LIST_CATEGORY:
        //     return {
        //         ...newState,
        //         dataCategory: action.payload
        //     }
        case Types.SAVE_LIST_IMAGE:
            return {
                ...newState,
                dataImage : action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
